import { format } from 'date-fns';

export const PROGRESS_TIMEFRAME_VALUES = ['2w', '1m', '3m', '6m', '1y', 'oldest'] as const;
export type ProgressTimeframe = (typeof PROGRESS_TIMEFRAME_VALUES)[number];

export const DEFAULT_PROGRESS_TIMEFRAME: ProgressTimeframe = '3m';

const DAYS_AFTER_TODAY = 365;

export const computeDateRange = (
  timeframe: ProgressTimeframe,
  today: Date,
): { from: string; to: string } | undefined => {
  if (timeframe === 'oldest') return undefined;

  const toDate = new Date(today);
  toDate.setDate(toDate.getDate() + DAYS_AFTER_TODAY);
  const to = format(toDate, 'yyyy-MM-dd');

  const from = new Date(today);
  switch (timeframe) {
    case '2w':
      from.setDate(from.getDate() - 14);
      break;
    case '1m':
      from.setMonth(from.getMonth() - 1);
      break;
    case '3m':
      from.setMonth(from.getMonth() - 3);
      break;
    case '6m':
      from.setMonth(from.getMonth() - 6);
      break;
    case '1y':
      from.setFullYear(from.getFullYear() - 1);
      break;
  }

  return { from: format(from, 'yyyy-MM-dd'), to };
};
